__turbopack_context__.v({
  "tabsDanger": "Tabs-module__ufiMyW__tabsDanger",
  "tabsDefault": "Tabs-module__ufiMyW__tabsDefault",
  "tabsPrimary": "Tabs-module__ufiMyW__tabsPrimary",
  "tabsSecondary": "Tabs-module__ufiMyW__tabsSecondary",
  "tabsSuccess": "Tabs-module__ufiMyW__tabsSuccess",
  "tabsUnderlined": "Tabs-module__ufiMyW__tabsUnderlined",
  "tabsWarning": "Tabs-module__ufiMyW__tabsWarning",
});
